import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface AuthDialogData {
  title?: string;
  message?: string;
  returnUrl?: string;
}

@Component({
  selector: 'app-common-auth-dialog',
  templateUrl: './common-auth-dialog.component.html',
  styleUrls: ['./common-auth-dialog.component.scss'],
})
export class CommonAuthDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CommonAuthDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AuthDialogData,
    private router: Router
  ) {
    // Set default values if not provided
    if (!this.data.title) {
      this.data.title = 'Authentication Required';
    }
    if (!this.data.message) {
      this.data.message = 'Please login or sign up to access this feature.';
    }
  }

  onLogin(): void {
    this.dialogRef.close('login');
    const returnUrl = this.data.returnUrl || this.router.url;
    this.router.navigate(['/auth/login'], {
      queryParams: { returnUrl },
    });
  }

  onSignup(): void {
    this.dialogRef.close('signup');
    const returnUrl = this.data.returnUrl || this.router.url;
    this.router.navigate(['/auth/signup'], {
      queryParams: { returnUrl },
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
